module.exports = __webpack_public_path__ + "img/noti-icon.8d62d469.svg";